export function parseJwt() {
  const token = localStorage.getItem('id_token');
  if (token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  }
  return null;
}

export function isTokenExpired() {
  const token = parseJwt();
  const now = Math.floor(Date.now() / 1000);

  if (token === null) return true;

  return token.exp < now;
}

export default {
  parseJwt,
  isTokenExpired,
};
